require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

import 'swiper/css/bundle';
import 'flatpickr/dist/flatpickr.css';

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/bootstrap-tab");
require("./vendor/jquery.inputmask");

require("./custom/global-forms.es6");
require("./custom/header.es6");
require("./custom/footer.es6");
require("./custom/anchor.es6");

(function ($) {

    if ($(".section-scrollTrigger").length > 0) {
        require("./custom/general-scroll-trigger.es6");
    }

    if ($(".section-hero").length > 0) {
        require("./page_builder/section_hero.es6");
    }

    if ($(".section-hero-type-2").length > 0) {
        require("./page_builder/section_hero_type_2.es6");
    }

    if ($(".section-media").length > 0) {
        require("./page_builder/section_media.es6");
    }

    if ($(".section-slider-groups").length > 0) {
        require("./page_builder/section_slider_groups.es6");
    }

    if ($(".section-slider-images").length > 0) {
        require("./page_builder/section_slider_images.es6");
    }

    if ($(".section-faq").length > 0) {
        require("./page_builder/section_faq.es6");
    }

    if ($(".section-slider-images-text").length > 0) {
        require("./page_builder/section_slider_images_text.es6");
    }

    if ($(".section-slider-images-text-type-2").length > 0) {
        require("./page_builder/section_slider_images_text_type_2.es6");
    }

    if ($(".section-our-media").length > 0) {
        require("./page_builder/section_our_media.es6");
    }

    if ($(".popup-form").length > 0) {
        require("./page_builder/popup_form.es6");
    }

    if ($(".section-small-groups-list").length > 0) {
        require("./page_builder/section_small_groups_list.es6");
    }

    if ($(".section-our-ministries-form").length > 0) {
        require("./page_builder/section_our_ministries_form.es6");
    }

    if ($(".section-accordion-with-image").length > 0) {
        require("./page_builder/section_accordion_with_image.es6");
    }

    if ($(".section-media-slider").length > 0) {
        require("./page_builder/section_media_slider.es6");
    }

    if ($(".section-contact-info-form").length > 0) {
        require("./page_builder/section_contact_info_form.es6");
    }

    if ($(".popup-make-a-donation").length > 0) {
        require("./page_builder/section_popup_make_a_donation.es6");
    }

    if ($(".section-news-list").length > 0) {
        require("./page_builder/section_news_list.es6");
    }

    if ($(".section-events-list").length > 0) {
        require("./page_builder/section_events_list.es6");
    }

    if ($(".section-recent-news").length > 0) {
        require("./custom/single-news.es6");
    }


})(jQuery);